var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8243 3.82654C5.59524 2.0556 8.4665 2.0556 10.2374 3.82654C12.0084 5.59748 12.0084 8.46874 10.2374 10.2397C8.4665 12.0106 5.59524 12.0106 3.8243 10.2397C2.05336 8.46874 2.05336 5.59748 3.8243 3.82654ZM12.0052 2.05878C9.25796 -0.688476 4.80378 -0.688476 2.05653 2.05877C-0.690719 4.80603 -0.690719 9.2602 2.05653 12.0075C4.50219 14.4531 8.30057 14.7216 11.0432 12.8129L13.8659 15.6356C14.354 16.1237 15.1455 16.1237 15.6336 15.6356C16.1218 15.1474 16.1218 14.3559 15.6336 13.8678L12.8109 11.0451C14.7193 8.30244 14.4507 4.50431 12.0052 2.05878Z",
    fill: "#00A3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSearch);
export default __webpack_public_path__ + "static/media/blue_search.3ec92ec45005ee182d31a414827de63c.svg";
export { ForwardRef as ReactComponent };